import { useRef, useCallback } from 'react';
import useIsomorphicEffect from './use-isomorphic-effect.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 *
 * @param value the value or function to persist
 */
function useCallbackRef(fn) {
  var ref = useRef(fn);
  useIsomorphicEffect(function () {
    ref.current = fn;
  }, [fn]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(function () {
    var _ref$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.call.apply(_ref$current, [ref].concat(args));
  }, []);
}

export { useCallbackRef as default };
//# sourceMappingURL=use-callback-ref.esm.js.map
